import React from 'react';
import clsx from 'clsx';
import { IconButton, useTheme } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useTranslate } from 'hooks/use-translate';
import style from './index.module.scss';

interface Props {
  /** The current page, from 1. */
  page: number;
  /** The number of pages. */
  pages: number;
  onChange: (page: number) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * N3 (T3, D-130): the pager of a list below md -- previous, "current of
 * total", next, on one row. The page numbers of the desktop pagers
 * (react-paginate, MUI's Pagination) wrapped onto a second line at 390 and
 * pushed the controls beside them off it. The owner keeps its page-size
 * select and its total beside this; the page state and the request are the
 * owner's, this only renders them. Nothing below two pages, like the pagers
 * it stands in for.
 */
export const AppPaginationCompact: React.FC<Props> = ({
  page,
  pages,
  onChange,
  disabled,
  className,
}) => {
  const { t } = useTranslate();
  const isRtl = useTheme().direction === 'rtl';
  if (!pages || pages < 2) {
    return null;
  }
  // "previous" points to the reading start: right in RTL
  const PrevIcon = isRtl ? KeyboardArrowRightIcon : KeyboardArrowLeftIcon;
  const NextIcon = isRtl ? KeyboardArrowLeftIcon : KeyboardArrowRightIcon;
  return (
    <div className={clsx(style.root, 'app-pagination-compact', className)}>
      <IconButton
        color={'primary'}
        aria-label={t('previous')}
        disabled={disabled || page <= 1}
        onClick={() => onChange(page - 1)}
      >
        <PrevIcon />
      </IconButton>
      <span className={style.state}>
        {page} {t('of')} {pages}
      </span>
      <IconButton
        color={'primary'}
        aria-label={t('next')}
        disabled={disabled || page >= pages}
        onClick={() => onChange(page + 1)}
      >
        <NextIcon />
      </IconButton>
    </div>
  );
};
